import { Component, useEffect, useState, useContext, useRef } from "react";
import { FarmContext } from "../../contexts/FarmContext";
import { useTranslation, withTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { withFormik, Form } from "formik";
import LoadingDialog from "../Utils/LoadingDialog";
import { callSend, FormRow, HeaderButtons, EmailChips } from "../Form/Form";
import "react-toastify/dist/ReactToastify.css";
import "../Form/FormStyles.css";
import withName from "../../hoc/withName";
import getBaseLangs from "../../utils/language";
import { validateEmail50, validateFullRut } from "../../components/Form/Validations";
import PromiseWrapper from "../Utils/PromiseDialog";
import { RestAPI } from "@aws-amplify/api-rest";
import { toast } from "react-toastify";
import { faPause, faPlay, faInfoCircle, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { dateFormat, getDateFromYearWeek, utcToDate } from "../../utils/date";

import DialogComponentWrapper from "../Utils/DialogComponentWrapper";
import SelfHelp from "../Utils/SelfHelp";
import Terms from "./Terms";
import Graph from "./Graph";
import ButtonPrime from "../PrimeComponents/ButtonPrime";
import TooltipPrime from "../PrimeComponents/TooltipPrime";
import CalendarPrime from "../PrimeComponents/CalendarPrime";
import { isInDateRange } from "../../utils/DataUtils";

import { localeOption } from "primereact/api";

const domain = /@wiseconn\..*/;
const pozo = "pozo_form";
/* const capitalize = (s) => {
  const lower = s.toLowerCase();
  if (typeof s !== 'string') return ''
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}; */

const getPozoId = (location) => {
    if (location.search.search("well") !== -1) {
        const params = new URLSearchParams(location && location.search);
        const pozo = params.get("well");
        return pozo;
    } else {
        return null;
    }
};

const getFarm = (location) => {
    const params = new URLSearchParams(location && location.search);
    const farm = params.get("farm");
    return farm;
};

const getGraphData = async (farmId, codObra, setGraphData, nodes, pozo, setFechaUltimoEnvioProtocol) => {
    let node_id = null;
    for (let i = 0; i < nodes.length; i++) {
        const sAcum = nodes[i]?.sensores?.find(s => s.sensor_id===pozo.sensor_acumulador_id);
        const sCau = nodes[i]?.sensores?.find(s => s.sensor_id===pozo.sensor_caudal_id);
        const sNiv = nodes[i]?.sensores?.find(s => s.sensor_id===pozo.sensor_nivel_id);
        if(sAcum|| sCau||sNiv){
            node_id = nodes[i].nodo_id;
            break;
        }
    }
    try {
        const data = await RestAPI.get("apiAdminDropControl", `/farms/${farmId}/graphdgadata/${codObra}`,{queryStringParameters: {"nodo_id":node_id}});
        setGraphData(data.datosEnviadosDGA);
        if(data?.dgaProtocol?.[0]?.codigoObras?.includes(codObra)){
            setFechaUltimoEnvioProtocol(getDateFromYearWeek(data?.dgaProtocol?.[0]?.ultimaFecha));
        }
    } catch (error) {
        console.log("error", error);
    }
};

const SwitchButton = ({ t, esta_habilitado, setHabilitado, farmId, pozoId, edit, usuarioConfigurado, dialogForConfigured, setDialogForConfigured, politicas }) => {
    const promiseW = useRef();
    const tapped = () => {
        if (esta_habilitado || usuarioConfigurado || politicas.accepted || politicas.updated) {
            promiseW.current?.getPromiseAnswer()?.then((del) => {
                const nuevoValor = !esta_habilitado;
                if (del) {
                    const param = `/farms/${farmId}/cambiarEstadoPozo/${pozoId}`;
                    const body = { esta_habilitado: nuevoValor };
                    RestAPI.post("apiAdminDropControl", param, { body: body })
                        .then(res => JSON.parse(JSON.stringify(res)))
                        .then(json => {
                            setHabilitado(nuevoValor);
                            toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                        })
                        .catch(err => {
                            console.error(err);
                            toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                        });
                } else {
                    toast.info(t("forms.toastInfo"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                }
            }
            );
        } else {
            setDialogForConfigured({ visible: true });
        }
    };

    return (
        <>
            <DialogComponentWrapper containerId="configurar_usuario_id" t={t} dialogState={dialogForConfigured} setDialogState={setDialogForConfigured} hideButtons>
                <div className="container-fluid text-center"><span>{(politicas.accepted || politicas.updated) ? t("farms.pozo.noEsPosibleHabilitarPozo") : t("farms.pozo.noEsPosibleHabilitarPozoTerminos")}</span></div>
            </DialogComponentWrapper>
            <PromiseWrapper ref={promiseW} yesText={t("general.answerYes")} noText={t("general.answerNo")}
                headerText={esta_habilitado ? t("forms.deshabilitar") : t("forms.habilitar")}
                contentText={esta_habilitado ? t("forms.dgaConfirmacionHabilitado") : t("forms.dgaConfirmacionDeshabilitado")}
            />

            <div >
                {esta_habilitado &&
            <TooltipPrime id="dga_disable" content={t("forms.deshabilitar")} position="bottom">
                <FontAwesomeIcon className="pointer" icon={faPause} style={{ color: "tomato", fontSize:"1.65rem", marginLeft:"15px" }} onClick={() => tapped()} />
            </TooltipPrime>}

                {!esta_habilitado &&
            <TooltipPrime id="dga_enable" content={t("forms.habilitar")} position="bottom">
                <FontAwesomeIcon className="pointer" icon={faPlay} style={{ color: "green", fontSize:"1.65rem", marginLeft:"15px" }} onClick={() => tapped()} />
            </TooltipPrime>}
            </div>
        </>
    );
};

const DownloadTermsDialog = ({ dato1, nombre1, t, downloadTermsDialog, setDownloadTermsDialog, pozoActual, fechaAceptacion }) => {
    return (
        <>
            <DialogComponentWrapper
                containerId="downloadTerms" t={t} dialogState={downloadTermsDialog}
                setDialogState={setDownloadTermsDialog} hideButtons
                width="800px"
            >
                <Terms setDialogState={setDownloadTermsDialog} pozoActual={pozoActual} fechaAceptacion={fechaAceptacion} printeable />
            </DialogComponentWrapper >
            <div className="row linea-formulario">
                <div className="col-12 col-md-6 text-md-right">
                    <label className='boldie'>{nombre1}</label>
                </div>
                <div className="col-12 col-md-6 text-md-left">
                    <span>{dato1 ? t("general.answerYes") : t("general.answerNo")} </span>
                    {dato1 && (pozoActual && fechaAceptacion) ? <a className="pointer" style={{ fontSize: "12px" }} onClick={() => setDownloadTermsDialog({ visible: true })}>({t("forms.ver")})</a>
                        :
                        null}
                </div>
            </div>
        </>
    );
};

const CodeLinkTemplate = ({code, t}) => {
    return (
        <div className="row linea-formulario">
            <div className="col-12 col-md-6 text-md-right">
                <label className='boldie'>{t("farms.pozo.codigoObra")}</label>
            </div>
            <div className="col-12 col-md-6 text-md-left">
                <span>{code} </span>
                <a className="pointer" style={{ fontSize: "12px" }} target="_blank" href={`https://snia.mop.gob.cl/cExtracciones2/#/detalleObraBP/${code}`}>({t("forms.ver")})</a>
            </div>
        </div>
    );
};
class PozoForm extends Component {
    //static contextType = TypesContext;
    componentDidUpdate(prevProps) {
        if (prevProps.status.edit && !this.props.status.edit) {
            this.props.setErrorEmail(null);
        }
    }

    render() {
        const { resetForm, status = {}, setStatus, data, values, touched, farmId, pozoId, timezone, canEdit, /* usuarioConfigurado, setUsuarioConfigurado, */
            t, i18n, handleSubmit, errors, errorEmail, setErrorEmail, chipsRef, esta_habilitado, setHabilitado, politicas, pozoAdmin,
            dialogForConfigured, setDialogForConfigured, downloadTermsDialog, setDownloadTermsDialog, fechaUltimoEnvioProtocol, usuarioInfo } = this.props;
        const isEdit = canEdit && status.edit;
        if (!data) return <div className="card col-xl-12 col-lg-12 col-sm-12"> <div className="card-body altura-min" /></div>;
        const [lang] = i18n && getBaseLangs(i18n);
        /* if (data.usuario_dga && data.password_dga) setUsuarioConfigurado(true);
    if (!data.usuario_dga && !data.password_dga) setUsuarioConfigurado(false); */

        if (errors.usuario_dga && errors.usuario_dga.includes("pass")) delete errors.usuario_dga;
        if (errors.password_dga && errors.password_dga.includes("rut")) delete errors.password_dga;
        if (values.password_dga && values.password_dga.length >= 4) delete errors.password_dga;

        const selfHelpImgAdd1 = import.meta.glob("../../img/autoayuda/*/autoayuda-pozo-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-pozo-1.png`];
        const selfHelpImgAdd2 = import.meta.glob("../../img/autoayuda/*/autoayuda-pozo-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-pozo-2.png`];
        const selfHelpImgAdd3 = import.meta.glob("../../img/autoayuda/*/autoayuda-pozo-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-pozo-3.png`];
        const selfHelpImgAdd4 = import.meta.glob("../../img/autoayuda/*/autoayuda-pozo-4.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-pozo-4.png`];
        const selfHelpImgAdd5 = import.meta.glob("../../img/autoayuda/*/autoayuda-pozo-5.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-pozo-5.png`];
        const selfHelpImgAdd6 = import.meta.glob("../../img/autoayuda/*/autoayuda-pozo-6.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-pozo-6.png`];
        const selfHelpImgAdd7 = import.meta.glob("../../img/autoayuda/*/autoayuda-pozo-7.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-pozo-7.png`];

        const selfSucces = import.meta.glob("../../img/autoayuda/*/autoayuda-success.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-success.png`];
        const selfInfo = import.meta.glob("../../img/autoayuda/*/autoayuda-info.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-info.png`];
        const selfError = import.meta.glob("../../img/autoayuda/*/autoayuda-error.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-error.png`];

        const selfHelpParams = [
            {
                tab: 1, header: { text: t("selfHelp.fertiTable.instEdit") }, params:
          [
              { id: 1, text: t("selfHelp.pozo.msgEdit1"), image: selfHelpImgAdd1 },
              { id: 2, text: t("selfHelp.pozo.msgEdit2"), image: selfHelpImgAdd2 },
              { id: 3, text: t("selfHelp.pozo.msgEdit3"), image: selfHelpImgAdd3 },
              { id: 4, text: t("selfHelp.pozo.msgEdit4"), image: selfHelpImgAdd4 },
              { id: 5, text: t("selfHelp.pozo.msgEdit5"), image: selfHelpImgAdd5 },
              { id: 6, text: t("selfHelp.fertiTable.msgAdd6"), image: [selfSucces, selfInfo, selfError] }
          ]
            },
            {
                tab: 2, header: { text: t("selfHelp.pozo.instHabilitar") }, params:
          [
              { id: 1, text: t("selfHelp.pozo.msgEdit6"), image: selfHelpImgAdd6 },
              { id: 2, text: t("selfHelp.pozo.msgEdit7"), image: selfHelpImgAdd7 },
              { id: 3, text: t("selfHelp.fertiTable.msgAdd6"), image: [selfSucces, selfInfo, selfError] }
          ],
            },
            {
                tab: 3, header: { text: t("selfHelp.properties") }, definition: true, params:
          [
              { id: 1, defName: t("selfHelp.pozo.usuarioConfigurado"), defText: t("selfHelp.pozo.defUsuarioConfigurado") },
              { id: 2, defName: `${t("farms.pozo.encargado")}: `, defText: t("selfHelp.pozo.defEncargado") },
          ],
            }
        ];
        return (
            <div className="card" >
                <div className="card-body">
                    <Form id={pozo} onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className='col-4'>
                                {selfHelpParams &&
                  <SelfHelp t={t} lng={i18n.language} params={selfHelpParams} fertiTable />}
                            </div>
                            <div className='col-4 text-center'>
                                <h5 className="card-title"><span>{t("farms.pozo.pozoInfo")}</span></h5>
                            </div>
                            <div className='col-4 d-flex justify-content-end align-items-center'>
                                {canEdit && pozoAdmin ?
                                    <div className='row col-12'>
                                        <div className='col-xl-8 col-12' />
                                        <div className='col-xl-2 col-12'>
                                            <SwitchButton
                                                t={t} esta_habilitado={esta_habilitado} setHabilitado={setHabilitado}
                                                edit={status.edit} farmId={farmId} pozoId={pozoId} usuarioConfigurado={(data.usuario_dga && data.password_dga) ? true : false}
                                                dialogForConfigured={dialogForConfigured} setDialogForConfigured={setDialogForConfigured} politicas={politicas}
                                            />
                                        </div>
                                        <div className='col-xl-2 col-12'>
                                            <HeaderButtons edit={status.edit} canEdit={canEdit} setStatus={setStatus} resetForm={resetForm} form={pozo} />
                                        </div>
                                    </div>
                                    :
                                    <HeaderButtons edit={status.edit} canEdit={canEdit} setStatus={setStatus} resetForm={resetForm} form={pozo} />}
                            </div>
                        </div>
                        <div className='linea-titulo' />

                        <div className='row'>
                            <div className='col-12 text-center'>
                                <CodeLinkTemplate
                                    code={data.codigo_obra}
                                    t={t}
                                />
                                <FormRow
                                    edit={false}
                                    dato1={data.tipo_obra === "SUBTERRANEA" ? t("farms.pozo.tipoObraSubterranea") : data.tipo_obra === "SUPERFICIAL" ? t("farms.pozo.tipoObraSuperficial") : null}
                                    nombre1={t("farms.pozo.tipoObra")}
                                    campo1="tipo_obra"
                                />
                                <FormRow
                                    edit={false}
                                    dato1={data.nombre}
                                    nombre1={t("general.name")}
                                    campo1="nombre"
                                />
                                <FormRow
                                    edit={false}
                                    dato1={(data.esta_habilitado === esta_habilitado ? data.esta_habilitado : esta_habilitado) ? t("general.answerYes") : t("general.answerNo")}
                                    nombre1={t("forms.habilitado")}
                                    campo1="esta_habilitado"
                                />
                                <EmailChips
                                    nombre={t("farms.pozo.reportesEmails")}
                                    emails_str={data.mails_envio_reporte}
                                    edit={isEdit}
                                    error={t(errorEmail)}
                                    setError={setErrorEmail}
                                    campoSolo={t("personal.email")}
                                    chipsRef={chipsRef}
                                    farmId={farmId}
                                    pozoId={pozoId}
                                />
                                <FormRow
                                    edit={false}
                                    dato1={(data.fecha_envio_dga === "" || data.fecha_envio_dga === null)
                                        ? "-" : dateFormat(utcToDate(data.fecha_envio_dga, timezone, true), t, i18n.language, timezone)}
                                    nombre1={t("farms.pozo.fechaUltimoDatoEnviado")}
                                    campo1="fecha_ultimo_dato_enviado"
                                />
                                {
                                    fechaUltimoEnvioProtocol && domain.test(usuarioInfo?.email??"")?
                                        <FormRow
                                            edit={false}
                                            dato1={(fechaUltimoEnvioProtocol === "" || fechaUltimoEnvioProtocol === null)
                                                ? "-" : t("date.weekFile",{"day":fechaUltimoEnvioProtocol.getDate(),"month":localeOption("monthNames")[fechaUltimoEnvioProtocol.getMonth()],"year":fechaUltimoEnvioProtocol.getFullYear()})}
                                            nombre1={t("farms.pozo.lastFile")}
                                            campo1="fecha_ultimo_dato_enviado"
                                        />
                                        :null
                                }
                                <FormRow
                                    edit={false}
                                    dato1={(data.usuario_id_encargado ? data.nombre_encargado : "-")}
                                    nombre1={t("farms.pozo.encargado")}
                                    campo1="nombre_encargado"
                                />
                                <DownloadTermsDialog
                                    edit={false}
                                    dato1={politicas.updated ? politicas.updated : data.aceptado_terminos}
                                    nombre1={t("farms.pozo.politicasAceptadas")}
                                    campo1="politicas_pozo_aceptadas"
                                    t={t}
                                    downloadTermsDialog={downloadTermsDialog}
                                    setDownloadTermsDialog={setDownloadTermsDialog}
                                    pozoActual={data}
                                    fechaAceptacion={politicas.fecha ?
                                        dateFormat(utcToDate(politicas.fecha, timezone, true), t, i18n.language, timezone, false, true)
                                        : !data.fecha_aceptacion_politica_pozo ?
                                            null
                                            : dateFormat(utcToDate(data.fecha_aceptacion_politica_pozo, timezone, true), t, i18n.language, timezone, false, true)}
                                />
                                <FormRow
                                    edit={false}
                                    dato1={politicas.fecha ? dateFormat(utcToDate(politicas.fecha, timezone, true), t, i18n.language, timezone) :
                                        (data.fecha_aceptacion_politica_pozo === "" || data.fecha_aceptacion_politica_pozo === null)
                                            ? "-" : dateFormat(utcToDate(data.fecha_aceptacion_politica_pozo, timezone, true), t, i18n.language, timezone)}
                                    nombre1={t("farms.pozo.fechaPoliticasAceptadas")}
                                    campo1="fecha_aceptacion_politica_pozo"
                                />

                                {isEdit && pozoAdmin &&
                  <FormRow
                      edit
                      dato1={data.usuario_dga}
                      nombre1={t("farms.pozo.usuarioDGA")}
                      campo1="usuario_dga"
                      validate1={validateFullRut}
                      error1={errors.usuario_dga && t(errors.usuario_dga)}

                      dato2={data.password_dga}
                      nombre2={t("farms.pozo.passwordDGA")}
                      campo2="password_dga"
                      type2="password"
                      validate2={validateFullRut}
                      error2={errors.password_dga && t(errors.password_dga)}
                      eyeForPassword
                  />}

                                <FormRow
                                    edit={false}
                                    dato1={/* usuarioConfigurado */ ((data.usuario_dga && data.password_dga) ? true : false) ? t("general.answerYes") : t("general.answerNo")}
                                    nombre1={t("farms.pozo.usuarioConfigurado")}
                                    campo1="usuario_configurado"
                                />
                                {
                                    data.usuario_dga && data.password_dga?
                                        <FormRow
                                            edit={false}
                                            dato1={/* usuarioConfigurado */ ((data.error_usuario_dga) ? true : false) ? t("general.answerYes") : t("general.answerNo")}
                                            nombre1={t("farms.pozo.errorUsuarioDGA")}
                                            campo1="usuario_configurado"
                                        />:null
                                }

                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

const formValidate = ({ email, usuario_dga, password_dga }) => {
    const errors = {};
    if (email) {
        const er = validateEmail50(email);
        if (er !== undefined) errors.email = er;
    }
    if (usuario_dga || password_dga) {
        const er = validateFullRut(usuario_dga, password_dga);

        if (er !== undefined) {
            const split = er.split("-");
            const prefix = split[0];
            const error = split[1];

            if (prefix == "pass") {
                errors.password_dga = error;
                /*  errors.usuario_dga = null; */
            }
            if (prefix == "user") {
                errors.usuario_dga = error;
                /* errors.password_dga = null; */
            }
            if (prefix == "rut") {
                errors.usuario_dga = error;
                /* errors.password_dga = null; */
            }
        }
    }
    return errors;
};

const FormikForm = withFormik({
    mapPropsToStatus: (props) => {
        return {
            edit: (props && props.edit) || false,
        };
    },
    mapPropsToValues: (props) => {
        const data = Object.assign({}, props.data);

        return {
            codigo_obra: data.codigo_obra,
            nombre: data.nombre,
            tipo_obra: data.tipo_obra,
            fecha_ultimo_dato_enviado: data.fecha_ultimo_dato_enviado,
            fecha_ultimo_reporte: data.fecha_ultimo_reporte,
            ultima_revision: data.ultima_revision,
            mails_envio_reporte: data.mails_envio_reporte,
            esta_habilitado: data.esta_habilitado,
            usuario_dga: data.usuario_dga,
            password_dga: data.password_dga,
            aceptado_terminos: data.aceptado_terminos,
            fecha_aceptacion_politica_pozo: data.fecha_aceptacion_politica_pozo,
            fecha_envio_dga: data.fecha_envio_dga
        };
    },
    validate: formValidate,
    enableReinitialize: true,
    handleSubmit: (values, { props, ...actions }) => {
        props.updateData(values, props);
        if (!props.cancel) actions.setStatus({ edit: false });
    }
})(withTranslation()(PozoForm));

const DGAWell = ({ dataFarm, pozosInfo, usuarioInfo, menuIsOpen, nodosInfo }) => {
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const pozoId = getPozoId(location); //dgas_mee_id
    const farmId = getFarm(location);
    const [pozoActual, setInfo] = useState({ isLoaded: false, data: null });
    const [_, dispatch] = useContext(FarmContext);
    const canEdit = dispatch({ type: "get", path: "canEdit" });
    const [errorEmail, setErrorEmail] = useState(null);
    const chipsRef = useRef(null);
    const [esta_habilitado, setHabilitado] = useState(false);
    const [loadingReq, setLoadingReq] = useState(false);
    const [rangeDates, setRangeDates] = useState(null);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [showValidation, setShowValidation] = useState(false);
    const [showValidation3M, setShowValidation3M] = useState(false);
    const [dialogState, setDialogState] = useState({ visible: false });
    const [politicas, setPoliticas] = useState({ updated: false, fecha: null, accepted: false });
    const [pozoAdmin, setPozoAdmin] = useState(false);
    const [graphData, setGraphData] = useState([]);
    const [fechaUltimoEnvioProtocol, setFechaUltimoEnvioProtocol] = useState(null);
    const [downloadTermsDialog, setDownloadTermsDialog] = useState({ visible: false });
    /* const [usuarioConfigurado, setUsuarioConfigurado] = useState(false); */

    const [dialogForConfigured, setDialogForConfigured] = useState({ visible: false });
    useEffect(() => {
        let isAdmin = false;
        pozoActual.data && setInfo({ isLoaded: false, data: null });
        pozosInfo.filter(pozo => pozo.pozo_id !== null);
        const pozo = pozosInfo.find(pozo => pozo.dgas_mee_id == pozoId);
        pozo && setInfo({ isLoaded: true, data: pozo });
        pozo && setHabilitado(pozo.esta_habilitado);
        pozoAdmin && setPozoAdmin(false);
        /* pozo.usuario_dga && pozo.password_dga && setUsuarioConfigurado(true); */
        pozo && pozo.aceptado_terminos && setPoliticas((state) => {
            return { ...state, accepted: true };
        });
        if (pozo && pozo.usuario_id_encargado !== null && usuarioInfo.usuario_id === pozo.usuario_id_encargado) {
            isAdmin = true;
            setPozoAdmin(isAdmin);
        }
        if (isAdmin && (!pozo.aceptado_terminos || pozo.usuario_id_encargado != pozo.usuario_aceptacion_terminos)) {
            setDialogState({ visible: true });
        }

        pozo && getGraphData(farmId, pozo.codigo_obra, setGraphData, nodosInfo, pozo, setFechaUltimoEnvioProtocol);
    }, [pozoId, pozosInfo]);

    const selfHelpImgDes1 = import.meta.glob("../../img/autoayuda/*/autoayuda-pozo-descarga-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-pozo-descarga-1.png`];
    const selfHelpImgDes2 = import.meta.glob("../../img/autoayuda/*/autoayuda-pozo-descarga-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-pozo-descarga-2.png`];
    const selfHelpImgDes3 = import.meta.glob("../../img/autoayuda/*/autoayuda-pozo-descarga-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-pozo-descarga-3.png`];
    const selfHelpImgDes4 = import.meta.glob("../../img/autoayuda/*/autoayuda-pozo-descarga-4.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-pozo-descarga-4.png`];

    const selfHelpDescarga = [
        {
            tab: 1, header: { text: t("selfHelp.pozo.instSolicitudDescarga") }, params:
        [
            { id: 1, text: t("selfHelp.pozo.msgDescarga1"), image: selfHelpImgDes1 },
            { id: 2, text: t("selfHelp.pozo.msgDescarga2"), image: selfHelpImgDes2 },
            { id: 3, text: t("selfHelp.pozo.msgDescarga3"), image: selfHelpImgDes3 },
            { id: 4, text: t("selfHelp.pozo.msgDescarga4"), image: selfHelpImgDes4 },
            { id: 5, text: t("selfHelp.pozo.msgDescarga5"), image: [] }
        ]
        }
    ];
    return (
        <div className='row-container'>
            {!pozoActual.isLoaded && <LoadingDialog />}
            <DialogComponentWrapper containerId="politicas-pozo" t={t} dialogState={dialogState} setDialogState={setDialogState} hideButtons noClosable width="800px">
                <Terms pozoId={pozoId} setPoliticas={setPoliticas} setDialogState={setDialogState} farmId={farmId} pozoActual={pozoActual.data} printeable={false} />
            </DialogComponentWrapper>

            <div className='row'>
                <div className="col-12">
                    <FormikForm
                        usuarioInfo={usuarioInfo}
                        farmId={farmId}
                        pozoId={pozoId}
                        data={pozoActual.data}
                        timezone={dataFarm.huso_horario}
                        canEdit={canEdit}
                        errorEmail={errorEmail}
                        setErrorEmail={setErrorEmail}
                        chipsRef={chipsRef}
                        esta_habilitado={esta_habilitado}
                        setHabilitado={setHabilitado}
                        politicas={politicas}
                        pozoAdmin={pozoAdmin}
                        /* usuarioConfigurado={usuarioConfigurado}
            setUsuarioConfigurado={setUsuarioConfigurado} */
                        updateData={(newData) => callSend(`/farms/${farmId}/pozo/${pozoId}`, pozoActual.data, newData, t, setInfo)}
                        dialogForConfigured={dialogForConfigured}
                        setDialogForConfigured={setDialogForConfigured}
                        downloadTermsDialog={downloadTermsDialog}
                        setDownloadTermsDialog={setDownloadTermsDialog}
                        nodosInfo={nodosInfo}
                        fechaUltimoEnvioProtocol={fechaUltimoEnvioProtocol}
                    />
                </div>

                <div className="col-xl-6 col-lg-12 col-sm-12">
                    <div id="cardDownload" className="card" >
                        {loadingReq && <LoadingDialog appendTo="self" />}
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-4'>
                                    {selfHelpDescarga &&
                    <SelfHelp t={t} lng={i18n.language} params={selfHelpDescarga} fertiTable />}
                                </div>
                                <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                    <h5 className="card-title"><span>{t("forms.descargaDatos")}</span></h5>
                                </div>
                            </div>
                            <div className='linea-titulo' />

                            <div className="row">
                                <div className="col-12 text-center">
                                    <div className="row linea-formulario">
                                        <div className="col-12 col-md-6 text-md-right mtem-05">
                                            <label className="boldie">{t("forms.rangoFechasDGA")}</label>
                                        </div>
                                        <div className="col-12 col-md-6 col-lg-3 text-md-left mtem-05">
                                            <CalendarPrime
                                                t={t}
                                                maxDaysRange={90}
                                                value={rangeDates}  onChange={(e) => setRangeDates(e.value)}
                                                locale={i18n.language}
                                                selectionMode="range"
                                            />
                                        </div>
                                    </div>
                                </div>
                                {showValidation &&
                  <div className="col-12 msgRawValidation">
                      <span>{t("forms.msgValidacionRangoFechas")}</span>
                  </div>}
                                {showValidation3M &&
                  <div className="col-12 msgRawValidation">
                      <span>{t("forms.msgValidacionRangoFechas3M")}</span>
                  </div>}
                                <div className="col-12 text-center">
                                    <ButtonPrime label={t("forms.btnSendRequest")} onClick={() => {
                                        const desde = rangeDates && Array.isArray(rangeDates) && rangeDates[0];
                                        const hasta = rangeDates && Array.isArray(rangeDates) && rangeDates[1];
                                        if (desde && hasta) {
                                            if(isInDateRange(desde,hasta,91)){
                                                setShowValidation3M(true);
                                                setLoadingReq(false);
                                                setShowValidation(false);
                                            }else{
                                                setLoadingReq(true);
                                                setShowValidation(false);
                                                setShowValidation3M(false);
                                                const body = {
                                                    farmId: farmId,
                                                    dateFrom: desde.toJSON(),
                                                    dateTo: hasta.toJSON(),
                                                    codigoObra: pozoActual.data.codigo_obra,
                                                    nombrePozo: pozoActual.data.nombre,
                                                    farmName: dataFarm.nombre,
                                                    nombreCuenta: dataFarm.razon_social,
                                                    lng: i18n.language
                                                };

                                                /* let newDesde = new Date(desde);
                        let newHasta = new Date(hasta);

                        let diferencia = dateDiffInDays(newDesde, newHasta);
                        if (diferencia >= 3) {
                          setShowValidation(true);
                        } */

                                                const param = `/farms/${farmId}/dgadownload/${pozoId}`;
                                                RestAPI.post("apiAdminDropControl", param, { body: body })
                                                    .then(res => JSON.parse(JSON.stringify(res)))
                                                    .then((data) => {
                                                        setLoadingReq(false);
                                                        setShowErrorMsg(false);
                                                        setShowSuccessMsg(true);
                                                    })
                                                    .catch(err => {
                                                        setLoadingReq(false);
                                                        setShowErrorMsg(true);
                                                        console.error(err);
                                                    });

                                            }
                                        } else {
                                            if (!rangeDates?.[1] || !rangeDates?.[0]) {
                                                setLoadingReq(false);
                                                setShowValidation(true);
                                                setShowValidation3M(false);
                                            }
                                        }
                                    }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {showSuccessMsg &&
            <div id="successForRaw" className="card"
                data-mdb-toggle="animation" data-mdb-animation-reset="onLoad" data-mdb-animation="fade-in-up "
            >
                <div className="row p-2">
                    <div className="col-12 col-md-1">
                        <div className="text-center pl-md-2 pt-md-2">
                            <FontAwesomeIcon size="2x" icon={faInfoCircle} style={{ color: "white" }} />
                        </div>
                    </div>
                    <div className="col-12 col-md-11">
                        <div className="rawMsg">
                            {t("forms.msgSuccesDGAReq").includes("\n") ?
                                t("forms.msgSuccesDGAReq").split("\n").map(text => {
                                    return <><span>{text}</span><br /></>;
                                })
                                :
                                <span>{t("forms.msgSuccesDGAReq")}</span>}
                        </div>
                    </div>
                </div>
            </div>}
                    {showErrorMsg &&
            <div id="errorForRaw" className="card"
                data-mdb-toggle="animation" data-mdb-animation-reset="onLoad" data-mdb-animation="fade-in-up "
            >
                <div className="row p-2">
                    <div className="col-12 col-md-1">
                        <div className="text-center pl-md-2 pt-md-2">
                            <FontAwesomeIcon size="2x" icon={faExclamationCircle} style={{ color: "white" }} />
                        </div>
                    </div>
                    <div className="col-12 col-md-11">
                        <div className="rawMsg">
                            {t("forms.msgErrorRawReq").includes("\n") ?
                                t("forms.msgErrorRawReq").split("\n").map(text => {
                                    return <><span>{text}</span><br /></>;
                                })
                                :
                                <span>{t("forms.msgErrorRawReq")}</span>}
                        </div>
                    </div>
                </div>
            </div>}
                </div>

                <div className="col-xl-6 col-lg-12 col-sm-12 map-col">
                    <div id="cardGraph" className="card">
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-4' />
                                <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                    <h5 className="card-title"><span>{t("forms.tituloGraficoDGA")}</span></h5>
                                </div>
                            </div>
                            <div className='linea-titulo' />
                            <Graph data={graphData} timezone={dataFarm.huso_horario} t={t} menuIsOpen={menuIsOpen} buildingType={pozoActual?.data?.tipo_obra ? pozoActual.data.tipo_obra : null} />
                        </div>
                    </div>
                </div>


            </div>
        </div>
    );
};

export default withName(DGAWell, "WellFrag");
